export const serviceEndPoint = {
  loginService: process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/login",
   securityService: process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/users",
  mentorMenteeMappingService:process.env.REACT_APP_API_ENDPOINT +"ssservices-v1/sservices-v1/menteedetails",
  scheduleService:process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/sservices-v1/schedule",
  answerSetService:process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/sservices-v1/feedback",
    // answerSetService:"http://localhost:8084/feedback",
  questionSetService:process.env.REACT_APP_API_ENDPOINT +"ssservices-v1/sservices-v1/questionset",
  FssSupport:process.env.REACT_APP_API_ENDPOINT +"ssservices-v1/sservices-v1/mentorActivity",
  documentService:process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/sservices-v1/documents",
  downloadDocumentService: process.env.REACT_APP_API_ENDPOINT + "Downloads/",
  batchDetailService:process.env.REACT_APP_API_ENDPOINT +"ssservices-v1/sservices-v1/batchdetails",
  moduleService: process.env.REACT_APP_REPORT_ENDPOINT + "moduleservices-v1",
  // FSCCreation: "http://localhost:8080/users",
  // FSCdeactivation: "http://localhost:8080/users",
  // facilitatoruser: "http://localhost:8082/menteedetails",
  // centerService: "http://localhost:8081",
  FSCCreation:process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/users",
  FSCdeactivation:process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/users",
  facilitatoruser:process.env.REACT_APP_API_ENDPOINT + "ssservices-v1/sservices-v1/menteedetails",
  centerService:process.env.REACT_APP_API_ENDPOINT + "services-v1",


  
};
